import React from "react";

export default function MapView({ mapRef }) {
  return (
    <div className="map-panel-container">
      <div ref={mapRef} className="map-view" style={{ width: "100%", height: "100%" }} />
    </div>
  );
}